import {q_hd, q_my_item} from './req'
import {baseUrls} from '@/utils/baseUrlConfig';
const shop_url = baseUrls.shop_url;
const current_season = 26;

export function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
export function closePage() {
    window.js_close();
}
export function replacePhoneToStar(number) {
    if (number) {
        return number.replace(/(\d{3})\d{4}(\d{4})/,'$1****$2');
    }
    return number
}
export function replaceEmailToStar(email) {
    if (String (email).indexOf ('@') > 0) {
        let newEmail, str = email.split('@'), _s = '';
        if (str[0].length > 4) {
            _s = str[0].substr (0, 4);
            for (let i = 0; i < str[0].length - 4; i++) {
                _s += '*';
            }
        } else {
            _s = str[0].substr (0, 1);
            for (let i = 0; i < str[0].length - 1; i++) {
                _s += '*';
            }
        }
        newEmail = _s + '@' + str[1];
        return newEmail;
    } else {
        return email;
    }
}

export function dateTimeFormate(date) {
    if (!date) {
        return
    } else {
        var d = new Date(date);
        var year = d.getFullYear();
        var month = ('0' + (d.getMonth() + 1)).slice(-2);
        var day = ('0' + (d.getDate())).slice(-2);
        var hour = ('0' + (d.getHours())).slice(-2);
        var minutes = ('0' + (d.getMinutes())).slice(-2);
        var seconds = ('0' + (d.getSeconds())).slice(-2);
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    }
}
// 比较日期
export function compare_b(date1, date2) {
    if (Date.parse(new Date(date1.replace(/-/g, '/'))) > Date.parse(new Date(date2.replace(/-/g, '/')))) {
        return true;
    } else {
        return false;
    }
}
// 获取随机数
export function getRandom(n, m){
    var val = (m - n + 1) * Math.random() + n;
    return Math.floor(val);
}
//深拷贝
export function deepCope(datas) {
    if (datas === null) {
        return null
    } else if (datas instanceof RegExp) {
        return new RegExp(datas)
    } else if (datas instanceof Date) {
        return new Date(datas)
    } else if (typeof datas !== 'object') {
        return datas
    } else {
        var obj = new datas.constructor();
        for (var i in datas) {
            obj[i] = deepCope(datas[i])
        }
        return obj;
    }
}
// 开通plus
export function openPlus(){
    window.onnewwindow('1100', '700', '40', 'https://www.09game.com/html/plus/index.html');
}

// 时间戳转换为距离现在多长时间
export function getTimeUntilNow(mss) {
    var days = parseInt(mss / (1000 * 60 * 60 * 24));
    if (days > 0) {
        return days + " 天前";
    };
    var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if (hours > 0) {
        return hours + " 小时前 ";
    };
    var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
    if (minutes > 0) {
        return minutes + " 分钟前 ";
    };
    var seconds = (mss % (1000 * 60)) / 1000;
    return "刚刚 ";
}

export const findLastIndex = function(array, cb){
    if(!Array.isArray(array)){
      return -1
    }
    if(array.length === 0){
      return -1
    }
    for(var i = array.length - 1; i >= 0; i--){
      const item = array[i];
      if (cb.call(null, item, i, array)) {
        return i
      }
    }
    return -1
  }
// 是否为今天
export function isToday(date, nowTime) {
    let d = new Date(date.toString().replace(/-/g, "/"));
    let now = nowTime ? nowTime: new Date();
    if (d.setHours(0, 0, 0, 0) == now.setHours(0, 0, 0, 0)) {
        return true;
    } else {
        return false;
    }
}
// 是否为本周
export function isCurrentWeek(past) {
    const pastTime = new Date(past).getTime()
    const today = new Date(new Date().toLocaleDateString())
    let day = today.getDay()
    day = day == 0 ? 7 : day
    const oneDayTime = 60*60*24*1000
    const monday = new Date(today.getTime() - (oneDayTime * (day - 1)))
    const nextMonday = new Date(today.getTime() + (oneDayTime * (8 - day)))
    if(monday.getTime() <= pastTime && nextMonday.getTime() > pastTime) {
      return true
    } else {
      return false
    }
  }
// 查询我的道具数量
export function query_my_item(id, token) {
    var amount = 0;
    $.ajax({
        url: shop_url + JSON.stringify({ type: 'q_my_item', json: JSON.stringify({ item_id: id, token: token }) }),
        async: false,
        success: (res) => {
            if (res.code == 0) {
                amount = res.records[0].amount;
            }
        }
    });
    return amount;
}
// 查询服务器当前时间
export function query_time() {
    let nowTime = null;
    $.ajax({
        url: 'https://webapi.09game.com/Home/GetDateNow',
        async: false,
        success: function (res) {
            if (res.code == 0) {
                var now = res.msg.toString().replace(/-/g, "/");
                nowTime = new Date(now);
            } else {
                nowTime = new Date();
            }
        }
    })
    return nowTime;
}
// 设置活动结束时间
export function setEndTime(endTime, nowTime){
    let now = nowTime ? nowTime: new Date();
    if (compare_b(dateTimeFormate(now), endTime)) {
        window.location.href = "https://www.09game.com/html/activityend/index.html";
    }
}
export function jumpToUrl(url){
    window.open(url);
}
// 跳转至新游戏
export function jumpToGame(gametypeid) {
    window.open('http://ninegame//action=entergamelist/?gametypeid=' + gametypeid);
    setTimeout(()=>{
        closePage();
    },1000)
}
export function changeIndex(array, index1, index2) {
  array[index1] = array.splice(index2, 1, array[index1])[0];
}
export function convertWar3Id(id){
    if (id <= 0) return "0";
    let t1 = String.fromCharCode(id & 255);
    let t2 = String.fromCharCode(id >> 8 & 255);
    let t3 = String.fromCharCode(id >> 16 & 255);
    let t4 = String.fromCharCode(id >> 24 & 255);
    return t4 + t3 + t2 + t1;
}
export function checkToken(token){
    if(!token) return false
    return new Date().getTime() < token.split('-')[3] * 1000
}
export function setUrlQuery(options) {
    let {url,query} = options;
    if(!url) return '';
    if(query) {
        let queryArr = [];
        for (const key in query) {
            if (query.hasOwnProperty(key)) {
                queryArr.push(`${key}=${query[key]}`)
            }
        }
        if(url.indexOf('?') !== -1) {
            url =`${url}&${queryArr.join('&')}`
        } else {
            url =`${url}?${queryArr.join('&')}`
        }
    }
    return url;
}

export function isIos(){
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        return 1;
    } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
        return 2;
    } else { //pc
        return 0;
    }
}

export function isMobile(){
    return /Mobile/i.test(navigator.userAgent) || /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function draw1(id, buff) {
  var board = document.getElementById(id);
  var context = board.getContext("2d");
  // 图像处理必须运行在服务器环境
  var aImg = new Image();
  aImg.src = "img/buff-light.png";
  board.height = board.height;
  context.beginPath();
  aImg.onload = function () {
    // 三个参数分别为 图片对象 画布位置(X轴 Y轴)
    context.drawImage(aImg, 5, 5);
    // getimageData--获取图片指定区域的像素
    let imageDatas = context.getImageData(5, 5, aImg.width, aImg.height)
    let dataArray = imageDatas.data;
    let newData = [];
    for (var i = 0; i < dataArray.length; i += 4) {
      newData.push(dataArray[i]);
      newData.push(dataArray[i + 1]);
      newData.push(dataArray[i + 2]);
      newData.push(dataArray[i + 3]);
      var r = dataArray[i];
      var g = dataArray[i + 1];
      var b = dataArray[i + 2];
      // 当 r = g = b 时会变成灰色(除了 0 0 0 和 255 255 255)
      // 取平均值
      var result = parseInt((r + g + b) / 3);
      dataArray[i] = result;
      dataArray[i + 1] = result;
      dataArray[i + 2] = result;
    }
    context.putImageData(imageDatas, 0, 0);
    for (var i = 1; i <= buff; i++) {
      drawDef(i, context)
    }
  }

};

export {
    current_season
}



// WEBPACK FOOTER //
// ./src/utils/common.js